import { useState } from "react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuCheckboxItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Columns } from "@phosphor-icons/react";

export function useColumnVisibility(storageKey, defaults) {
  const [visible, setVisible] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey));
      return saved ? { ...defaults, ...saved } : defaults;
    } catch {
      return defaults;
    }
  });
  const toggle = (key) =>
    setVisible((v) => {
      const next = { ...v, [key]: !v[key] };
      try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch { /* ignore */ }
      return next;
    });
  return [visible, toggle];
}

export function ColumnsToggle({ columns, visible, onToggle }) {
  const hiddenCount = columns.filter((c) => !visible[c.key]).length;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="columns-toggle-btn"
          className="flex items-center gap-2 bg-white border border-slate-200 text-navy px-4 py-2.5 rounded-lg text-sm font-medium hover:border-navy hover:bg-navy/5 transition-colors">
          <Columns size={16} /> Columns{hiddenCount ? ` (${hiddenCount} hidden)` : ""}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel>Show columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {columns.map((c) => (
          <DropdownMenuCheckboxItem key={c.key} checked={!!visible[c.key]}
            onCheckedChange={() => onToggle(c.key)}
            onSelect={(e) => e.preventDefault()}
            data-testid={`col-toggle-${c.key}`}>
            {c.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
